const styles = () => ({
  wrapper: {
    margin: '0 !important',
  },
});

export default styles;
